import { container } from '@/container';
import { UserController } from '@/controllers/UserController';
import { Connection } from '@/services/Connection';
import { Environment } from '@/services/Environment';
import { RouterGuard } from '@/services/router/types';

/**
 * Redirect if CAD is not yet initialized.
 */
export const initializeGuard: RouterGuard = async function initializeGuard(to, from, next) {
  const environment = await container.getAsync(Environment);
  const connection = await container.getAsync(Connection);
  const userController = await container.getAsync(UserController);

  if (connection.isInitialized) {
    next();
  }
  else if (userController.activeUser.roles.isZollAdmin()) {
    window.location.replace(environment.zdAdminBaseUrl);
    next(false);
  }
  else {
    next({ name: 'error', query: { code: 'NotInitialized' } });
  }
};
